/* =========================================================
   LSF COACHING+ — Module PROGRAMMES
   - Programmes multi-semaines cliquables et configurés
   - Progression LINÉAIRE verrouillée (on suit le plan, pas de saut)
   - Suivi d'avancement (séances faites / total, %) + reprise
   ========================================================= */

(function () {
  'use strict';

  var KEY = 'lsf_programs_v1';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  var ST = load();
  function doneOf(id) { return (ST[id] && ST[id].done) || 0; }
  function setDone(id, n) { ST[id] = ST[id] || {}; ST[id].done = n; save(ST); }

  var SESS = {
    reveil:  { n: 'Réveil énergique',     d: 20, i: '🌅' },
    brule:   { n: 'Brûle-graisses',       d: 30, i: '🔥' },
    abdos:   { n: 'Tonification abdos',   d: 25, i: '🎯' },
    recup:   { n: 'Récupération active',  d: 20, i: '🌿' },
    complet: { n: 'Renfo complet',        d: 28, i: '⭐' }
  };

  var PROGRAMS = {
    debutant: {
      id: 'debutant', name: 'EMS Débutant', sub: '4 semaines · 3 séances / semaine',
      grad: 'linear-gradient(135deg,#5B3FBF,#2A1B5E)',
      desc: "Reprenez le sport en douceur et installez l'habitude. Intensité progressive, idéal pour (re)commencer sans se blesser.",
      weeks: [
        { label: 'Sem. 1 · Adaptation',       days: ['reveil', 'abdos', 'recup'] },
        { label: 'Sem. 2 · Régularité',       days: ['reveil', 'abdos', 'recup'] },
        { label: 'Sem. 3 · Montée en charge', days: ['reveil', 'complet', 'recup'] },
        { label: 'Sem. 4 · Consolidation',    days: ['abdos', 'complet', 'recup'] }
      ]
    },
    tonification: {
      id: 'tonification', name: 'Tonification', sub: '6 semaines · 4 séances / semaine',
      grad: 'linear-gradient(135deg,#7A5AE0,#2A1B5E)',
      desc: "Galbez et raffermissez tout le corps. Ciblage abdos, fessiers et bras pour une silhouette tonique et une meilleure posture.",
      weeks: [
        { label: 'Sem. 1 · Activation', days: ['abdos', 'reveil', 'recup', 'abdos'] },
        { label: 'Sem. 2 · Galbe',      days: ['abdos', 'complet', 'recup', 'abdos'] },
        { label: 'Sem. 3 · Renfort',    days: ['complet', 'abdos', 'recup', 'complet'] },
        { label: 'Sem. 4 · Intensif',   days: ['complet', 'abdos', 'brule', 'recup'] },
        { label: 'Sem. 5 · Sculpt',     days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 6 · Finition',   days: ['complet', 'brule', 'abdos', 'recup'] }
      ]
    },
    'perte-poids': {
      id: 'perte-poids', name: 'Perte de poids', sub: '8 semaines · 5 séances / semaine',
      grad: 'linear-gradient(135deg,#FF6B00,#C24E00)',
      desc: "Brûlez un maximum de calories avec un mix cardio + EMS. Programme exigeant et efficace pour transformer durablement votre corps.",
      weeks: [
        { label: 'Sem. 1 · Démarrage',    days: ['brule', 'abdos', 'reveil', 'brule', 'recup'] },
        { label: 'Sem. 2 · Combustion',   days: ['brule', 'complet', 'abdos', 'brule', 'recup'] },
        { label: 'Sem. 3 · Accélération', days: ['brule', 'complet', 'brule', 'abdos', 'recup'] },
        { label: 'Sem. 4 · Choc',         days: ['brule', 'complet', 'brule', 'complet', 'recup'] },
        { label: 'Sem. 5 · Relance',      days: ['brule', 'abdos', 'brule', 'complet', 'recup'] },
        { label: 'Sem. 6 · Intensif',     days: ['brule', 'complet', 'brule', 'complet', 'recup'] },
        { label: 'Sem. 7 · Sprint',       days: ['brule', 'complet', 'brule', 'abdos', 'brule'] },
        { label: 'Sem. 8 · Finition',     days: ['brule', 'complet', 'brule', 'complet', 'recup'] }
      ]
    },
    muscu: {
      id: 'muscu', name: 'Musculation', sub: '10 semaines · 4 séances / semaine',
      grad: 'linear-gradient(135deg,#2A1B5E,#5B3FBF)',
      desc: "Développez votre masse musculaire avec l'EMS. Intensité croissante sur 10 semaines pour un maximum d'hypertrophie.",
      weeks: [
        { label: 'Sem. 1 · Adaptation',   days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 2 · Volume',       days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 3 · Charge',       days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 4 · Densité',      days: ['complet', 'abdos', 'complet', 'brule'] },
        { label: 'Sem. 5 · Force',        days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 6 · Hypertrophie', days: ['complet', 'abdos', 'complet', 'brule'] },
        { label: 'Sem. 7 · Intensité',    days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 8 · Surcharge',    days: ['complet', 'abdos', 'complet', 'brule'] },
        { label: 'Sem. 9 · Pic',          days: ['complet', 'abdos', 'complet', 'recup'] },
        { label: 'Sem. 10 · Affûtage',    days: ['complet', 'recup', 'complet', 'recup'] }
      ]
    }
  };

  function flat(p) {
    var a = [];
    p.weeks.forEach(function (w) { w.days.forEach(function (s) { a.push(s); }); });
    return a;
  }

  var curOpen = null, pending = null;

  function ensureDom() {
    if (document.getElementById('lsf-program')) return;
    var el = document.createElement('div');
    el.id = 'lsf-program';
    el.className = 'lsf-pgm';
    el.innerHTML =
      '<div class="lsf-pgm__bar-top">' +
        '<button class="lsf-pgm__close" data-prog-close aria-label="Fermer">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '<div class="lsf-pgm__top-title" id="lsf-pgm-toptitle"></div>' +
        '<span style="width:38px;"></span>' +
      '</div>' +
      '<div class="lsf-pgm__scroll" id="lsf-pgm-scroll"></div>' +
      '<div class="lsf-pgm__cta" id="lsf-pgm-cta"></div>';
    document.body.appendChild(el);
  }

  function openProgram(id) {
    if (!PROGRAMS[id]) return;
    ensureDom();
    curOpen = id;
    document.getElementById('lsf-program').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    render(id);
    document.getElementById('lsf-pgm-scroll').scrollTop = 0;
  }

  function closeOverlay() {
    var el = document.getElementById('lsf-program');
    if (el) el.classList.remove('is-open');
    curOpen = null;
    document.body.style.overflow = '';
    renderCards();
    insertBanner();
  }

  function render(id) {
    var p = PROGRAMS[id];
    var fl = flat(p), tot = fl.length;
    var done = Math.min(doneOf(id), tot);
    var pct = Math.round(done / tot * 100);

    document.getElementById('lsf-pgm-toptitle').textContent = p.name;

    var html =
      '<div class="lsf-pgm__hero" style="background:' + p.grad + ';">' +
        '<div class="lsf-pgm__htag">PROGRAMME</div>' +
        '<h1 class="lsf-pgm__hname">' + p.name + '</h1>' +
        '<p class="lsf-pgm__hsub">' + p.sub + '</p>' +
        '<p class="lsf-pgm__hdesc">' + p.desc + '</p>' +
        '<div class="lsf-pgm__progress"><div class="lsf-pgm__progress-bar" style="width:' + pct + '%;"></div></div>' +
        '<div class="lsf-pgm__progress-lbl">' + done + ' / ' + tot + ' séances · ' + pct + '%</div>' +
      '</div>';

    var gi = 0;
    p.weeks.forEach(function (w) {
      html += '<div class="lsf-pgm__week"><div class="lsf-pgm__wlabel">' + w.label + '</div>';
      w.days.forEach(function (sid) {
        var s = SESS[sid];
        var st = gi < done ? 'done' : (gi === done ? 'current' : 'lock');
        html += '<div class="lsf-pday lsf-pday--' + st + '">' +
          '<span class="lsf-pday__ic">' + (st === 'done' ? '✓' : (st === 'lock' ? '🔒' : s.i)) + '</span>' +
          '<span class="lsf-pday__body"><strong>' + s.n + '</strong><small>' + s.d + ' min</small></span>' +
          (st === 'lock'
            ? '<span class="lsf-pday__locktxt">Verrouillé</span>'
            : '<button class="lsf-pday__go" data-launch="' + sid + '" data-prog-go="' + id + '" data-prog-idx="' + gi + '">' + (st === 'done' ? 'Refaire' : 'Démarrer') + '</button>') +
          '</div>';
        gi++;
      });
      html += '</div>';
    });

    document.getElementById('lsf-pgm-scroll').innerHTML = html;

    var cta;
    if (done >= tot) {
      cta = '<button type="button" class="lsf-btn lsf-btn--gold" data-prog-restart="' + id + '">Programme terminé 🎉 Recommencer</button>';
    } else {
      cta = '<button type="button" class="lsf-btn lsf-btn--gold" data-launch="' + fl[done] + '" data-prog-go="' + id + '" data-prog-idx="' + done + '">' +
        (done === 0 ? 'Commencer le programme' : 'Continuer · séance ' + (done + 1) + '/' + tot) + '</button>';
    }
    document.getElementById('lsf-pgm-cta').innerHTML = cta;
  }

  function renderCards() {
    Array.prototype.slice.call(document.querySelectorAll('.lsf-prog[data-program]')).forEach(function (card) {
      var id = card.dataset.program;
      var p = PROGRAMS[id];
      if (!p) return;
      var tot = flat(p).length;
      var done = Math.min(doneOf(id), tot);
      var pct = Math.round(done / tot * 100);
      var wrap = card.querySelector('.lsf-prog__pwrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'lsf-prog__pwrap';
        wrap.innerHTML = '<div class="lsf-prog__pbar"></div>';
        card.appendChild(wrap);
      }
      wrap.querySelector('.lsf-prog__pbar').style.width = pct + '%';
      var lbl = card.querySelector('.lsf-prog__plbl');
      if (!lbl) {
        lbl = document.createElement('div');
        lbl.className = 'lsf-prog__plbl';
        card.appendChild(lbl);
      }
      lbl.textContent = done > 0 ? (done + '/' + tot + ' séances · ' + pct + '%') : 'Appuyez pour découvrir';
    });
  }

  function insertBanner() {
    var home = document.querySelector('.lsf-home');
    if (!home) return;
    var ex = document.getElementById('lsf-pgm-banner');
    var pick = null;
    Object.keys(PROGRAMS).forEach(function (id) {
      var tot = flat(PROGRAMS[id]).length, d = doneOf(id);
      if (d > 0 && d < tot && !pick) pick = id;
    });
    if (!pick) { if (ex) ex.parentNode.removeChild(ex); return; }
    var p = PROGRAMS[pick], tot = flat(p).length, d = doneOf(pick), pct = Math.round(d / tot * 100);
    var html =
      '<div class="lsf-pgmbanner__tag">PROGRAMME EN COURS</div>' +
      '<div class="lsf-pgmbanner__row">' +
        '<div><strong>' + p.name + '</strong><span>Prochaine : séance ' + (d + 1) + '/' + tot + ' · ' + pct + '%</span></div>' +
        '<button type="button" class="lsf-btn lsf-btn--gold" data-prog-continue="' + pick + '">Continuer</button>' +
      '</div>' +
      '<div class="lsf-pgmbanner__bar"><i style="width:' + pct + '%;"></i></div>';
    if (!ex) {
      ex = document.createElement('div');
      ex.id = 'lsf-pgm-banner';
      ex.className = 'lsf-pgmbanner';
      var lc = home.querySelector('.lsf-levelcard');
      if (lc && lc.nextSibling) home.insertBefore(ex, lc.nextSibling);
      else home.insertBefore(ex, home.firstChild);
    }
    ex.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.lsf-prog[data-program]');
    if (card) { openProgram(card.dataset.program); return; }

    if (e.target.closest('[data-prog-close]')) { closeOverlay(); return; }

    var cont = e.target.closest('[data-prog-continue]');
    if (cont) { openProgram(cont.dataset.progContinue); return; }

    var rs = e.target.closest('[data-prog-restart]');
    if (rs) { setDone(rs.dataset.progRestart, 0); render(rs.dataset.progRestart); renderCards(); insertBanner(); return; }

    var go = e.target.closest('[data-prog-go]');
    if (go) { pending = { id: go.dataset.progGo, idx: +go.dataset.progIdx }; return; }

    if (e.target.closest('#lsf-finish-close')) {
      if (pending) {
        var id = pending.id;
        if (pending.idx === doneOf(id)) setDone(id, doneOf(id) + 1);
        pending = null;
        setTimeout(function () {
          renderCards();
          insertBanner();
          if (curOpen) { render(curOpen); document.body.style.overflow = 'hidden'; }
        }, 60);
      }
      return;
    }

    if (e.target.closest('#lsf-player-close')) { pending = null; }
  });

  function start() { renderCards(); insertBanner(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
